@if (isFetching) {
    <div class="wish-preview-card">
        <div class="wish-preview-card__header">
            <figure>
                <ngx-skeleton-loader [theme]="{height: '100%', width: '100%', marginBottom: 0}"></ngx-skeleton-loader>
            </figure>
        </div>
        <div class="wish-preview-card__footer">
              <ngx-skeleton-loader [theme]="{height: '20px', width: '70%', marginBottom: 0}"></ngx-skeleton-loader>
              <ngx-skeleton-loader [theme]="{height: '20px', width: '70%', marginBottom: 0}"></ngx-skeleton-loader>
              <ngx-skeleton-loader [theme]="{height: '20px', width: '70%', marginBottom: 0}"></ngx-skeleton-loader>
        </div>
    </div>
} @else {
    @if (wish) {
        <div class="wish-preview-card">
            <div class="wish-preview-card__header">
                <figure>
                    @if ((wish.favorites | getFavoritesByProvider: placeProvider.BOOKING).length; as bookingLength) {
                      <img [src]="(wish.favorites | getFavoritesByProvider: placeProvider.BOOKING)[bookingLength - 1]?.additionalData?.image?.ThumbnailUrl | safeUrl" alt="country-image">
                    } @else {
                      <img [src]="wish?.imageUrl | safeUrl" alt="country-image">
                    }
                </figure>
              <div class="wish-preview-card__header__title">
                <h3>{{ wish.cityName }}</h3>
              </div>
            </div>
            <div class="wish-preview-card__footer">
                <button>
                    @if ((wish.favorites | getFavoritesByProvider: placeProvider.BOOKING).length; as count) {
                        <span class="badge">{{ count }}</span>
                    }
                    Hotels
                </button>
                <button>
                    @if ((wish.favorites | getFavoritesByProvider: placeProvider.VIATOR).length; as count) {
                        <span class="badge">{{ count }}</span>
                    }
                    Activities
                </button>
                <button>
                    @if ((wish.favorites | getFavoritesByProvider: placeProvider.GENIUS).length; as count) {
                        <span class="badge">{{ count }}</span>
                    }
                    Events
                </button>
            </div>
        </div>
    }
}
